module.exports = __webpack_public_path__ + "static/img/31.761a9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/31.png
// module id = 4oqh
// module chunks = 0